import { render, staticRenderFns } from "./ReportR2.vue?vue&type=template&id=30f1cf9e&scoped=true&"
import script from "./ReportR2.vue?vue&type=script&lang=js&"
export * from "./ReportR2.vue?vue&type=script&lang=js&"
import style0 from "./ReportR2.vue?vue&type=style&index=0&id=30f1cf9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f1cf9e",
  null
  
)

export default component.exports